export let EDITOR_TYPE = /*#__PURE__*/function (EDITOR_TYPE) {
  EDITOR_TYPE["ADI"] = "onboarding";
  EDITOR_TYPE["Editor"] = "editor";
  EDITOR_TYPE["EditorX"] = "editor_x";
  return EDITOR_TYPE;
}({});
//# sourceMappingURL=editor-type.js.map